import React from 'react';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Header = () => {
  return (
    <header className="w-full py-2 sm:py-4 px-3 sm:px-6 flex justify-between items-center border-b">
      <div className="flex items-center gap-1 sm:gap-2">
        <Link to="/" className="font-bold text-lg sm:text-xl text-primary">
          Crossable
        </Link>
      </div>
      <nav className="flex gap-2 sm:gap-4">
        <Button variant="ghost" size="sm" className="px-2 sm:px-4" asChild>
          <Link to="/">Home</Link>
        </Button>
        <Button variant="ghost" size="sm" className="px-2 sm:px-4" asChild>
          <Link to="/explore">Explore</Link>
        </Button>
        <Button variant="ghost" size="sm" className="px-2 sm:px-4" asChild>
          <Link to="/create">Create</Link>
        </Button>
      </nav>
    </header>
  );
};

export default Header;
